import React from 'react'
import BlogCards from './BlogCards'

export default function BlogSection({blog}) {
  return (
    <section class="text-gray-400 font-Avro mt bg-gray-900">
  <div class="container px-5 py-24 mx-auto">
  <div class="flex flex-wrap w-full mb-20">
      <div class="lg:w-1/2 w-full mb-6 lg:mb-0">
        <h1 class="sm:text-5xl text-4xl font-medium title-font mb-2 text-white">Blogs</h1>
        <div class="h-1 w-20 bg-indigo-500 rounded"></div>
      </div>
      <p class="lg:w-1/2 w-full leading-relaxed text-gray-400 text-opacity-90">This is Sameer Ijaz , I am a young entrepreneur, researcher on space exploration, cosmos, blackholes and quazars.
Moreover a computer programmer and a silver ranked chess player @chess.com</p>
    </div>
    
    <div class="md:flex md:flex-wrap grid grid-cols-1 -m-4">
    
    {
      blog.map((data)=>{
        return (<BlogCards cardData={data}/>)
      })
    }
    
    
    
    
    </div>
  </div>
</section>
  )
}
